import type { GQL } from "@binale-tech/shared";

export type ITransaction = GQL.IBankingTransaction;
